import axios from "axios";
import params from "../configs/params";

const baseUnifiApi = axios.create({
  baseURL: params.unifiUrl, 
  withCredentials: true,
});

baseUnifiApi.defaults.headers.common["Content-Type"] = "application/json";
baseUnifiApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

// Add a request interceptor for adding the Authorization header
baseUnifiApi.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for handling 401 errors
baseUnifiApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          const response = await axios.post(`${params.apiUrl}auth/token/refresh/`, { token: refreshToken });
          const newAccessToken = response.data.accessToken;
          localStorage.setItem("accessToken", newAccessToken);
          axios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axios(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default baseUnifiApi;